import { ChangeEvent, useRef } from "react";
import { Button, ButtonProps } from "./button";

export const FileUploadButton = ({
  onUpload,
  accept = "image/*",
  multiple = false,
  ...buttonProps
}: ButtonProps & {
  onUpload: (files: FileList) => void;
  multiple?: boolean;
  accept?: string;
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files) {
      onUpload(files);
    }
  };

  return (
    <>
      <input
        type="file"
        accept={accept}
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="image-upload"
        className="!hidden"
        multiple={multiple}
        ref={inputRef}
      />

      <Button
        {...buttonProps}
        onClick={() => {
          if (inputRef?.current) {
            inputRef.current.click();
          }
        }}
      />
    </>
  );
};
